import { render, staticRenderFns } from "./BlockPropertiesPanel.vue?vue&type=template&id=2b4be04a&scoped=true&"
import script from "./BlockPropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./BlockPropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlockPropertiesPanel.vue?vue&type=style&index=0&id=2b4be04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4be04a",
  null
  
)

export default component.exports